import { useMutation, useQueryClient } from 'react-query'

import AIGenerationService from 'src/services/ai-generation.service'

import { QUERY_KEYS } from 'src/constants'
import { getUserIdAndRolesFromToken } from 'src/common/utils'

const useGeneratedWebChatbotResponce = () => {
  const queryClient = useQueryClient()

  const userData = getUserIdAndRolesFromToken()

  const userId = userData?.id

  return useMutation(
    QUERY_KEYS.GENERATE_ASSISTANT_MESSAGE,
    (message: string) =>
      AIGenerationService.generateUserChatBotResponse({
        message,
      }),
    {
      onSuccess(data) {
        queryClient.invalidateQueries([QUERY_KEYS.WEB_CHATBOT_HISTORY, userId])
      },
    },
  )
}

export { useGeneratedWebChatbotResponce }
